import React from 'react'
import { Route, Switch } from 'react-router-dom'

import * as routes from 'routes'

import EditPasswordView from './EditPasswordView'
import View from './View'

const User = () => (
  <Switch>

    <Route path={routes.accountEditPassword()} render={() => (
      <EditPasswordView isAccount />
    )} />

    <Route path={routes.account()} render={() => (
      <View isAccount />
    )} />

  </Switch>
)

export default User



// WEBPACK FOOTER //
// ./src/containers/User/index.js